var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7826 1.17395H9.17391C7.97826 1.17395 7 2.15221 7 3.34786V46.8261C7 48.0218 7.97826 49 9.17391 49H41.7826C42.9783 49 43.9565 48.0218 43.9565 46.8261V3.34786C43.9565 2.15221 42.9783 1.17395 41.7826 1.17395ZM39.6087 44.6522H11.3478V5.52178H39.6087V44.6522ZM15.9674 35.4131C15.9674 34.2174 16.9457 33.2392 18.1413 33.2392H32.8152C34.0109 33.2392 34.9891 34.2174 34.9891 35.4131C34.9891 36.6087 34.0109 37.587 32.8152 37.587H18.1413C16.9457 37.587 15.9674 36.6087 15.9674 35.4131ZM16.2935 25.087C16.2935 23.8913 17.2717 22.9131 18.4674 22.9131H32.7609C33.9565 22.9131 34.9348 23.8913 34.9348 25.087C34.9348 26.2826 33.9565 27.2609 32.7609 27.2609H18.4674C17.2717 27.2609 16.2935 26.2826 16.2935 25.087ZM16.2935 14.7609C16.2935 13.5653 17.2717 12.587 18.4674 12.587H32.7609C33.9565 12.587 34.9348 13.5653 34.9348 14.7609C34.9348 15.9566 33.9565 16.9348 32.7609 16.9348H18.4674C17.2717 16.9348 16.2935 15.9566 16.2935 14.7609Z",
    fill: "#5D5FEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.7a55f34c77ebb5330ffcb95758d0c958.svg";
export { ForwardRef as ReactComponent };